import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastProvider } from './components/Toast';
import './styles/index.css';
import { armPushRegistration } from './lib/push';
armPushRegistration(); // native iOS only; silent no-op on web

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
});

// Register Service Worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });

      console.log('[App] Service Worker registered:', registration.scope);

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available
              console.log('[App] New version available');
              // Optionally show update notification to user
            }
          });
        }
      });

      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('[App] Message from SW:', event.data);

        if (event.data.type === 'SYNC_ORDERS') {
          // Trigger order sync
          import('./services/offline').then(({ offlineService }) => {
            offlineService.syncPendingItems();
          });
        }

        if (event.data.type === 'SYNC_PAYMENTS') {
          // Trigger payment sync
          import('./services/offline').then(({ offlineService }) => {
            offlineService.syncPendingItems();
          });
        }
      });

      // Register for background sync if supported
      if ('sync' in registration) {
        // Request permission for background sync
        navigator.permissions?.query({ name: 'background-sync' as PermissionName }).then((result) => {
          if (result.state === 'granted') {
            console.log('[App] Background sync permission granted');
          }
        }).catch(() => {
          // Permission API may not support background-sync query
        });
      }
    } catch (error) {
      console.error('[App] Service Worker registration failed:', error);
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
